module.exports = __webpack_public_path__ + "static/media/GoTPicker-Logo__white.fd55bddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GoTPicker-Logo__white.png
// module id = 87
// module chunks = 0